// extracted by mini-css-extract-plugin
module.exports = {"tabModuleMobileWrapper":"tabModuleMain_tabModuleMobileWrapper__vR_sB","tabModuleDesktopWrapper":"tabModuleMain_tabModuleDesktopWrapper__EO_wz"};